<template>
    <!-- NOTIFICATIONS -->
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
        <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" style="color:white" :badge="unreadNotificationsNum"/>

        <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

            <div class="notification-top text-center p-5 bg-primary text-white">
                <h3 class="text-white">{{ unreadNotificationsNum }} {{ $t('notification.unreadNotice') }}</h3>
            </div>
            <div class="notification-top w-full text-center text-gray bg-white p-3 seen-notify"
                style="border-bottom: 0.025rem solid #ebe9f1;">
                <span class="float-right cursor-pointer text-primary" @click="seenAllNotify">{{ $t('notification.markWatched') }}</span>
            </div>
            <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10"
                                 :settings="settings" :key="$vs.rtl">
                <ul class="bordered-items">
                    <li @click="openUrl(ntf)" v-for="ntf in unreadNotifications" :key="ntf.index" :style="ntf.style"
                        class="flex justify-between px-4 py-4 notification cursor-pointer">
                        <div class="flex items-start">
                            <feather-icon :icon="ntf.icon"
                                          :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
                            <div class="mx-2">
                                <span class="font-medium block notification-title"
                                      :class="[`text-${ntf.category}`]">{{ ntf.title }}
                                </span>
                                <div class="w-full">
                                    <small v-if="ntf.details">( {{ntf.details}} )</small>
                                </div>
                                <small>{{ ntf.msg }}</small>
                            </div>
                        </div>
                        <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.createdDate) }}</small>
                    </li>
                </ul>
            </VuePerfectScrollbar>

            <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer">
                <!-- <span>View All Notifications</span> -->
            </div>
        </vs-dropdown-menu>
    </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    components: {
        VuePerfectScrollbar
    },
    data() {
        return {
            listBranchs: [],
            listDepartment: [],
            listEmployee: [],
            selectedNtf: {},
            unreadNotifications: [],
            unreadNotificationsNum: 0,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
        }
    },
    methods: {
        getAllEmployee: function(){
            return new Promise((resolve, reject) => {
                this.$crm.post('/employee/all', {}).then((res) => {
                this.listEmployee = res.data
                resolve();
            }).catch(() => {reject()})
            })
        },
        seenAllNotify: function(){
            this.$vs.loading();
            this.$crm.post('notification/seen_all').then(async () => {
                this.$vs.loading.close();
                await this.loadNotifications();
            }).catch(() => {this.$vs.loading.close();})
        },
        async openUrl(ntf) {
            await this.seenNotification(ntf.id);
            let body = JSON.parse(ntf.body);
            let url = body.screenUrl;
            if (url && url.trim().length) {
                // url = url + "?" + this.buildUrlParams(body.params)
                if (url == '/user/attendance') url = url.concat(`?isCheckin=false&classId=${body.params.id}&teachingScheduleId=${body.params.teachingScheduleId}&date=${new Date(body.params.sendDate).getTime()}`);
                await this.routeByUrl(url);
                if (body) this.routerByParams(body.screenUrl);
                if (body.screenUrl == window.location.pathname) window.location.reload();
            } else {
            setTimeout(async () => {
                await this.loadNotifications();
            }, 500)
             }
        },
        routeByUrl: function(url){
            return new Promise((resolve, reject) => {
                this.$router.push('/');
                this.$router.push(url);
                resolve();
            }).catch((err) => {reject();})
        },
        routerByParams: function(paramUrl){
            switch (paramUrl) {
                case '/user/over-time':
                    this.$eventBus.$emit('notify-detail-overtime', true);
                    break;
                case '/user/edit-leave':
                    this.$eventBus.$emit('notify-detail-leave', true);
                    break;
                case 'user/meeting-schedule':
                    this.$eventBus.$emit('notify-detail-meeting', true);
                    break;
                case 'user/employee-location-checkin':
                    this.$eventBus.$emit('notify-detail-checkinLocation', true);
                    break;
            }
        },
        seenNotification: function(id){
            return new Promise((resolve, reject) => {
                this.$crm.post('/notification/seen/' + id).then(async res => {
                    await this.loadNotifications();
                    resolve();
                }).catch((err) => {
                    reject();
                })
            })
        },
        openUrlInPopup() {
            let body = JSON.parse(this.selectedNtf.data.body)
            c.then((response) => {
            }).catch((err) => {
            }).finally(() => {
                let url;
                if (body.screenUrl && body.params) {
                    url = body.screenUrl;
                }
                if (url && url.trim().length) {
                    url = url + "?" + this.buildUrlParams(body.params)
                    location.href = url
                } else {
                    setTimeout(async () => {
                        await this.loadNotifications();
                    }, 500)
                }
            });
        },
        buildUrlParams(urlParams) {
            let str = "";
            Object.keys(urlParams).forEach(key => {
                if (key == "id") str += "id=" + urlParams[key] + "&";
                if (key == "organizationBranchId") str += "branch_id=" + urlParams[key] + "&";
                if (key == "employeeId") str += "employeeId=" + urlParams[key] + "&"
            })
            return str;
        },
        elapsedTime(startTime) {
            let x = new Date(startTime)
            let now = new Date()
            var timeDiff = now - x
            timeDiff /= 1000

            var seconds = Math.round(timeDiff)
            timeDiff = Math.floor(timeDiff / 60)

            var minutes = Math.round(timeDiff % 60)
            timeDiff = Math.floor(timeDiff / 60)

            var hours = Math.round(timeDiff % 24)
            timeDiff = Math.floor(timeDiff / 24)

            var days = Math.round(timeDiff % 365)
            timeDiff = Math.floor(timeDiff / 365)

            var years = timeDiff

            if (years > 0) {
                return years + (years > 1 ? this.$t('notification.year') : this.$t('notification.year')) + this.$t('notification.ago')
            } else if (days > 0) {
                return days + (days > 1 ? this.$t('notification.day') : this.$t('notification.day')) + this.$t('notification.ago')
            } else if (hours > 0) {
                return hours + (hours > 1 ? this.$t('notification.hour') : this.$t('notification.hour')) + this.$t('notification.ago')
            } else if (minutes > 0) {
                return minutes + (minutes > 1 ? this.$t('notification.minute') : this.$t('notification.minute')) + this.$t('notification.ago')
            } else if (seconds > 0) {
                return (seconds > 1 ? seconds + this.$t('notification.secAgo') : this.$t('notification.justNow'))
            }

            return this.$t('notification.justNow')
        },
        // Method for creating dummy notification time
        loadNotifications() {
            return new Promise((resolve, reject) => {
                this.$crm.post('/notification/list', {}).then((response) => {
                    this.$vs.loading.close();
                    this.unreadNotifications = response.data.map(item => {
                        let body = JSON.parse(item.body);
                        if (this.listEmployee.length > 0) {
                            this.listEmployee.forEach(el => {
                                if (body.params && el.employeeId == body.params.employeeId) {
                                    item.fullName = el.fullName;
                                    item.employeeId = el.employeeCode;
                                }
                            })
                        }
                        this.listBranchs.forEach(el => {
                            if (el.id == item.organizationBranchId) item.branchName = el.organizationBranchName;
                        })
                        item.msg = JSON.parse(item.body).content;
                        item.style = {
                            'background-color': item.seenStatus == 0 ? '#edf2fa' : '#fff'
                        }
                        return item;
                    });
                    this.unreadNotifications = this.unreadNotifications.map(el => {
                        el.details = '';
                        if (el.fullName) el.details = el.details.concat(' - ', el.fullName);
                        if (el.employeeId) el.details = el.details.concat(' - ', el.employeeId);
                        if (el.details.charAt(1) == '-') el.details = el.details.slice(2)
                        return el;
                    })
                    this.unreadNotificationsNum = this.unreadNotifications.reduce((unreadNum, item) => {
                        if (item.seenStatus == 0) unreadNum++;
                        return unreadNum;
                    }, 0)
                    resolve();
                }).catch(() => {
                    reject();
                    this.$vs.loading.close();
                });
            })
        },
        capitalizeFirstLetter: function(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },
    async created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.listBranchs = branchList.map(el => {
            return {
                label: el.organizationBranchName,
                value: el.id,
                patch: el.patch
            }
        });

        await this.getAllEmployee();
        await this.loadNotifications();
        if (this.$messaging) {
            this.$messaging.onMessage((payload) => {
                if (payload.data.type != "user") return
                this.selectedNtf = payload;
                setTimeout(() => {
                    this.loadNotifications()
                }, 500)
                return this.$vs.notify({
                    text: payload.notification.title,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success',
                    click: this.openUrlInPopup

                });
            });
        }
    },
}

</script>
<style lang="scss">
.seen-notify {
    font-size:12px ;
    /* color: #b9b9c3; */
    float: right;
    height: 40px;
}
.con-vs-dropdown--menu {
    max-height: 500px !important;
}
.vs-dropdown--menu {
    max-height: 490px !important;
}
</style>
